import React from 'react';
import './index.scss';
import Android from '@opm/assets/svg/Android.svg';
import IOS from '@opm/assets/svg/iOS.svg';
import PC from '@opm/assets/svg/PC.svg';
import BubbleCommon from '@op/components/BubbleCommon';

const iconMap: any = {
  // 平台名称 -> 图片 URL 映射
  Android,
  IOS,
  PC,
};

export interface IPlatformItemProps {
  /** List of platform names */
  list: string[];
  /** Icon size (default: 16) */
  iconSize?: number;
  className?: string;
}

/**
 * PlatformItem — shows up to 3 platform icons
 */
export default function PlatformItem({
  list,
  iconSize = 16,
  className,
}: IPlatformItemProps) {
  if (!list || list.length === 0) return null;

  const visible = list.slice(0, 3);

  return (
    <div className={`dbom-platform-item ${className}`}>
      {visible.map((name: string, idx: number) => {
        const src = iconMap[name];
        if (!src) return null;
        return (
          <BubbleCommon
            placement="top"
            key={idx}
            tipsMap={null}
            showIcon={false}
            content={name}
          >
            <img
              src={src}
              alt={name}
              style={{ width: iconSize, height: iconSize }}
              className="dbom-platform-item__icon"
            />
          </BubbleCommon>
        );
      })}
    </div>
  );
}
